import SimpleTimeline from '../classes/SimpleTimeline';

const mainMenuContainer = document.querySelector('.header-nav');
const mainMenuSeparator = document.querySelector('.header .separator');
const mobilePreloader = document.getElementById('mobile-preloader');
const headerLogo = document.querySelector('.header-logo');

const sectionSelector = '.home-page-header-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const photoContainer = query('.home-page-header-section-image');
    const photoWrap = query('.home-page-header-section-image-wrap');
    const logoPreloaderPlaceholder = query('.logo-preloader-placeholder');
    const pageTitle = query('.home-page-header-section-title');
    const pageHasScroll = () => document.body.offsetHeight > window.innerHeight;

    const setLogoPosition = () => {
        const logoRect = headerLogo.getBoundingClientRect();
        const placeholderRect = logoPreloaderPlaceholder.getBoundingClientRect();
        const scale = (placeholderRect.width / logoRect.width).toFixed(2);
        const translateX = Math.round(placeholderRect.left - logoRect.left);
        const translateY = Math.round(placeholderRect.top - logoRect.top);
        headerLogo.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    };

    const animateDesktopPreloader = () => {
        const rect = photoContainer.getBoundingClientRect();
        photoWrap.style.top = `-${rect.top}px`;
        photoWrap.style.left = `-${rect.left}px`;
        photoWrap.style.right = `-${rect.left}px`;
        photoWrap.style.bottom = `-${window.innerHeight - rect.bottom}px`;

        setLogoPosition();
        mainMenuContainer.classList.add('before-animation');
        mainMenuSeparator.classList.add('before-animation');
        pageTitle.classList.add('before-animation');

        const timeline = new SimpleTimeline();
        timeline.add(() => {
            document.body.classList.add('animated');
        }, 300);

        timeline.add(() => {
            // eslint-disable-next-line no-shadow
            const rect = photoContainer.getBoundingClientRect();
            photoWrap.classList.add('animated');
            photoWrap.style.top = `-${rect.top - rect.left}px`;
            photoWrap.style.left = '0';
            photoWrap.style.right = '0';
        }, 1500);

        timeline.add(() => {
            photoWrap.style.top = '0';
            headerLogo.style.transitionDuration = '2s';
            headerLogo.style.transform = '';
        }, 600);

        timeline.add(() => {
            pageTitle.classList.add('animated');
        }, 1200);

        timeline.add(() => {
            mainMenuContainer.classList.add('animated');
            mainMenuSeparator.classList.add('animated');
        }, 200);

        timeline.add(() => {
            photoWrap.style.bottom = '0';
        }, 600);

        timeline.run();
    };

    const animateMobilePreloader = async () => {
        mobilePreloader.classList.add('active');
        document.body.classList.add('animated');
        setTimeout(() => {
            mobilePreloader.classList.add('hidden');
        }, 600);
    };

    const animatePreloader = () => {
        if (pageHasScroll()) {
            animateMobilePreloader();
        } else {
            animateDesktopPreloader();
        }
    };
    window.addEventListener('load', animatePreloader);
};

export { sectionSelector, sectionCallBack };
